import { UseBaseMutationOptions } from '@/core/api/type'
import { useMutation } from '@tanstack/react-query'
import { CarouselMutationKeys } from '../../../keys'
import {
	CreateCarouselItemsRequest,
	CreateCarouselItemsResponse,
} from '../../../type'
import { createCarouselItems } from '../../services'

interface UseMutationCreateCarouselItemProps {
	payload: CreateCarouselItemsRequest
}

export default function useMutationCreateCarouselItem(
	props?: UseBaseMutationOptions<
		CreateCarouselItemsResponse,
		UseMutationCreateCarouselItemProps
	>,
) {
	return useMutation({
		mutationKey: [CarouselMutationKeys.CreateCarouselItem],
		mutationFn: (params) => createCarouselItems(params.payload),
		...props,
	})
}
